import { date } from 'quasar';  

export default {
  data () {
    return {
      columns: [
        {
          label: 'Название',
          field: 'service_name',
          name: 'name',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Номер счёта',
          field: 'bill_number',
          name: 'bill_number',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Описание',
          field: 'description',
          name: 'description',
          sortable: false,
          align: 'left'
        },
        {
          label: 'Многоразовый',
          field: 'service_reusable',
          name: 'reusable',
          sortable: true,
          filter: '',
          align: 'left',
          format: value => value ? 'Да' : 'Нет'
        },
        {
          label: 'Видимый',
          field: 'service_visibleForCustomers',
          name: 'visibleForCustomers',
          sortable: true,
          filter: '',
          align: 'left',
          format: value => value ? 'Да' : 'Нет'
        },
        {
          label: 'Тип',
          field: 'service_type',
          name: 'type',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Автосписывание',
          field: 'service_chargingAutomatically',
          name: 'chargingAutomatically',
          sortable: true,
          filter: '',
          align: 'left',
          format: value => value ? 'Да' : 'Нет'
        },
        {
          label: 'Действителен с',
          field: 'valid_from',
          name: 'valid_from',
          sortable: true,
          filter: '',
          align: 'left',
          format: value => date.formatDate(value, 'DD.MM.YYYY')
        },
        {
          label: 'Действителен до',
          field: 'valid_until',
          name: 'valid_until',
          sortable: true,
          filter: '',
          align: 'left',
          format: value => date.formatDate(value, 'DD.MM.YYYY')
        },
        {
          label: 'Активный',
          name: 'active',
          field: 'active',
          sortable: false,
          filter: '',
          align: 'left',
          format: value => value ? 'Да' : 'Нет'
        },
        {
          label: 'Действия',
          name: 'edit',
          field: 'id',
          sortable: false,
          align: 'right'
        }
      ],
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServicesList/mixins/columns.js